// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"PB-z","smallCardRow":"QB-z","largeCardRow":"RB-z","productSearchRow":"SB-z","curatedRow":"TB-z"};